import React, { PureComponent } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LazyLoad from 'react-lazyload';
import moment from "moment";
import { RENT_SET, CALENDAR_TYPES } from "../store/helpers/constantVariables";
import guild from "../store/helpers/guid";
import ActionCreators from "../store/actions";
import {
    dateCarsWeekDaysView,
    dateCarsDayHoursView,
    dateCarsWeekDaysViewDisplayinPopout
} from "../store/helpers/dateHelper";
import Axios from "../config/AxiosConfig";
import Filters from "../Components/FiltersComponent/FiltersComponent";
import CarsCalendarComponent from "../Components/CarsViewComponent/CarsCalendarComponent";
import ReservationDialog from "../Components/ReservationDialogComponent/ReservationDialog";
import CarsViewWrapper from '../Components/CarsViewWrapper';
import HeaderCarsView from '../Components/HeaderCarsView';
import CarRowMultipleDaysView from '../Components/CarRowMultipleDaysView';
import CarRowOneDayView from '../Components/CarRowOneDayView';
import PopperComponent from "../Components/CarsViewComponent/PopperComponent";
import { withStyles } from "@material-ui/core";

const filtersHeight = 78;
const expandFiltersHeight = 0;

const useStyles = theme => ({
    drawer: {
        height: filtersHeight,
        position: "relative",
        overflow: "hidden"
    },
    calendar: {
        overflow: "auto",
        height: window.innerHeight - (70 + 72 + expandFiltersHeight),
        position: "relative",
        transition: theme.transitions.create(["margin", "height"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.complex
        }),
        marginTop: 0,
        width: "100%"
    },
    calendarShift: {
        overflow: "auto",
        position: "relative",
        height: window.innerHeight - (64 + expandFiltersHeight + filtersHeight),
        transition: theme.transitions.create("height", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.complex
        }),
    },
    expandFilters: {
        height: expandFiltersHeight,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginRight: theme.spacing(3)
    }
});

export class CarsView extends PureComponent {
    state = {
        laodedF: Math.round(window.innerHeight / 70),
        renderCom: false,
        filteredCars: [],
        brandFilter: "",
        textFilter: "",
        modelFilter: "",
        fuelFilter: "",
        gearboxFilter: "",
        show: false,
        isDialogOpen: false,
        isEdit: false,
        carId: "",
        rent: { ...RENT_SET },
    };

    cellRef = React.createRef();
    carImageRef = React.createRef();
    carDetailRef = React.createRef();
    gridContainedRef = React.createRef();
    timRender = null;

    onDialogCloseHandler = () => {
        this.setState({ isDialogOpen: false });
    };

    onDaySelectedHandler = startDate => {
        this.props.setPeriodDataHandle({
            periodStartDate: startDate,
            periodEndDate: startDate.clone().endOf("day"),
            periodDaysCount: 1
        });

        this.props.onSetCalendarType(CALENDAR_TYPES.PERIOD);
    };

    onFetchRentHandler = rent => {
        this.setState({ rent }, () => this.onDialogOpenHandler(true, null, rent));
    };

    onRentChangeHandler(event) {
        const rent = { ...this.state.rent };
        if (
            event.target.name === "czas_od" ||
            event.target.name === "czas_do" ||
            event.target.name === "data_prawa_jazdy"
        ) {
            rent[event.target.name] = moment(event.target.value).unix();
        } else {
            rent[event.target.name] = event.target.value;
        }
        this.setState({ rent });
    }

    onDialogOpenHandler = (isEdit = false, startDate, rent = null) => {
        if (rent) {
            this.setState({
                isDialogOpen: true,
                isEdit
            }, () => {
            });
        } else {

            var date = moment.unix(startDate).format("YYYY-MM-DD")
            var time = moment().format("HH:mm");

            const dateFrom = moment(`${date} ${time}`);
            const dateTo = moment(dateFrom).add(24, "hours");

            this.setState({
                isDialogOpen: true,
                isEdit,
                rent: {
                    ...RENT_SET,
                    czas_od: dateFrom.unix(),
                    czas_do: dateTo.unix(),
                }
            }, () => {
            });
        }
    };

    onCarIdChangeHandler = carId => {
        this.setState({ carId });
    };

    getCorrectDateByType = () => {
        const {
            calendarType,

            periodStartDate,
            periodEndDate,
            periodDaysCount,

            weekStartDate,
            weekEndDate,
            weekDaysCount,

            monthStartDate,
            monthEndDate,
            monthDaysCount,

            quarterStartDate,
            quarterEndDate,
            quarterDaysCount
        } = this.props;

        switch (calendarType) {
            case CALENDAR_TYPES.WEEK: {
                this.setState({
                    startDate: weekStartDate,
                    endDate: weekEndDate,
                    daysCount: weekDaysCount
                });
                return {
                    startDate: weekStartDate,
                    endDate: weekEndDate,
                    daysCount: weekDaysCount
                };
            }
            case CALENDAR_TYPES.MONTH: {
                this.setState({
                    startDate: monthStartDate,
                    endDate: monthEndDate,
                    daysCount: monthDaysCount
                });
                return {
                    startDate: monthStartDate,
                    endDate: monthEndDate,
                    daysCount: monthDaysCount
                };
            }
            case CALENDAR_TYPES.PERIOD: {
                this.setState({
                    startDate: periodStartDate,
                    endDate: periodEndDate,
                    daysCount: periodDaysCount
                });
                return {
                    startDate: periodStartDate,
                    endDate: periodEndDate,
                    daysCount: periodDaysCount
                };
            }
            case CALENDAR_TYPES.QUARTER: {
                this.setState({
                    startDate: quarterStartDate,
                    endDate: quarterEndDate,
                    daysCount: quarterDaysCount
                });
                return {
                    startDate: quarterStartDate,
                    endDate: quarterEndDate,
                    daysCount: quarterDaysCount
                };
            }
            default:
                break;
        }
    };

    onFiltersResetHandler = () => {
        this.setState({
            brandFilter: "",
            textFilter: "",
            modelFilter: "",
            fuelFilter: ""
        });
    };

    resizeHandle = () => {
        if (!this.state.isDialogOpen) {
            this.setState({ key: Math.random() });
        }
    };

    onTextFilterChangeHandler = value => {
        this.setState({
            textFilter: value,
            renderCom: false,
            laodedF: Math.round(window.innerHeight / 70)
        });
    };

    onBrandFilterChangeHandler = event => {
        this.setState({
            brandFilter: event.target.value,
            modelFilter: "",
            renderCom: false,
            laodedF: Math.round(window.innerHeight / 70)
        });
    };

    onModelFilterChangeHandler = event => {
        this.setState({
            modelFilter: event.target.value,
            renderCom: false,
            laodedF: Math.round(window.innerHeight / 70)
        });
    };

    onFuelFilterChangeHandler = event => {
        this.setState({
            fuelFilter: event.target.value,
            renderCom: false,
            laodedF: Math.round(window.innerHeight / 70)
        });
    };

    onGearboxFilterChangeHandler = event => {
        this.setState({
            gearboxFilter: event.target.value,
            renderCom: false,
            laodedF: Math.round(window.innerHeight / 70)
        });
    }

    fetchCars = () => {
        let { startDate, endDate } = this.getCorrectDateByType();
        endDate = endDate.endOf("day");

        this.props.fetchCars(this.props.token, startDate, endDate);
        this.setState({
            laodedF: Math.round(window.innerHeight / 70)
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.resizeHandle);
        var objTable = document.getElementById("calendar");
        if (objTable) {
            const context = this;
            objTable.addEventListener("scroll", function (e) {
                let filteredCars = [...context.props.cars];

                if (context.state.textFilter) {
                    filteredCars = filteredCars.filter(car => {
                        const filterWords = context.state.textFilter.split(" ");
                        const values = Object.values(car).map(val => typeof val === "string" ? val.toLowerCase() : val);
                        return values.some(val => {
                            for (let index = 0; index < filterWords.length; index++) {
                                return val.includes(filterWords[index].toLowerCase().trim());
                            }
                        });
                    });
                }

                if (context.state.brandFilter) {
                    filteredCars = filteredCars.filter(car => {
                        if (car.marka === context.state.brandFilter) {
                            return car;
                        }
                    });
                }

                if (context.state.modelFilter) {
                    filteredCars = filteredCars.filter(car => {
                        if (car.model === context.state.modelFilter) {
                            return car;
                        }
                    });
                }

                if (context.state.fuelFilter) {
                    filteredCars = filteredCars.filter(car => {
                        if (car.rodz_paliwo === context.state.fuelFilter) {
                            return car;
                        }
                    });
                }

                if (context.state.gearboxFilter) {
                    filteredCars = filteredCars.filter(car => {
                        if (car.skrzynia_biegow === context.state.gearboxFilter) {
                            return car;
                        }
                    });
                }


                if (context.state.laodedF <= filteredCars.length) {
                    const body = objTable;
                    const html = document.documentElement;
                    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

                    console.log("window.innerHeight", window.innerHeight);

                    if (docHeight >= document.querySelector("#calendar").scrollTop + window.innerHeight) {
                    } else {
                        context.setState({
                            laodedF: context.state.laodedF + window.innerHeight / 70
                        })
                    }
                }
            }, false);
        }
    }

    componentWillMount() {
        let { startDate, endDate } = this.getCorrectDateByType();
        endDate = endDate.endOf("day");

        this.props.fetchCars(this.props.token, startDate, endDate);
        this.props.fetchClients(this.props.token);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeHandle);
    }

    cancelRentHandler = id => {
        const { token } = this.props;

        this.props.cancelRent({ token: token, id_wynajem: id })
            .then(() => this.props.onRemoveType(id));
    };

    editRentHandler = id => {
        this.props.loader(true);
        Axios.post("kalendarz/pokaz_wynajem.php", {
            token: this.props.token,
            id_wynajem: id
        })
            .then(response => {
                const rent = response.data.klient[0];
                this.onFetchRentHandler(rent)
            })
            .finally(() => {
                this.props.loader(false);
            });
    };

    componentWillReceiveProps(newProps) {
        const { token } = newProps;

        if (this.props.fethPeriod !== newProps.fethPeriod) {
            let { periodStartDate, periodEndDate } = newProps;
            this.props.fetchCars(token, periodStartDate, periodEndDate);
            this.setState({ laodedF: Math.round(window.innerHeight / 70) })
        }

        if (this.props.fethWeek !== newProps.fethWeek) {
            const { weekStartDate, weekEndDate } = newProps;
            this.props.fetchCars(token, weekStartDate, weekEndDate);
            this.setState({ laodedF: Math.round(window.innerHeight / 70) })
        }

        if (this.props.fethMonth !== newProps.fethMonth) {
            let { monthStartDate, monthEndDate } = newProps;
            monthEndDate = monthEndDate.add(1, "days");
            this.props.fetchCars(token, monthStartDate, monthEndDate);
            this.setState({ laodedF: Math.round(window.innerHeight / 70) })
        }

        if (this.props.fethQuarter !== newProps.fethQuarter) {
            const { quarterStartDate, quarterEndDate } = newProps;
            this.props.fetchCars(token, quarterStartDate, quarterEndDate);
            this.setState({ laodedF: Math.round(window.innerHeight / 70) })
        }
    }

    render() {
        let { startDate, endDate, daysCount } = this.getCorrectDateByType();
        let cellWidth = !!this.cellRef && this.cellRef.getBoundingClientRect && this.cellRef.getBoundingClientRect().width;
        const carPositions = [];
        const { classes } = this.props;

        daysCount = Math.floor(daysCount);
        let filteredCars = [...this.props.cars];

        if (this.state.textFilter) {
            filteredCars = filteredCars.filter(car => {
                const filterWords = this.state.textFilter.split(" ");
                const values = Object.values(car).map(val => typeof val === "string" ? val.toLowerCase() : val);
                return values.some(val => {
                    for (let index = 0; index < filterWords.length; index++) {
                        return val.includes(filterWords[index].toLowerCase().trim());
                    }
                });
            });
        }

        if (this.state.brandFilter) {
            filteredCars = filteredCars.filter(car => {
                if (car.marka === this.state.brandFilter) {
                    return car;
                }
            });
        }

        if (this.state.modelFilter) {
            filteredCars = filteredCars.filter(car => {
                if (car.model === this.state.modelFilter) {
                    return car;
                }
            });
        }

        if (this.state.fuelFilter) {
            filteredCars = filteredCars.filter(car => {
                if (car.rodz_paliwo === this.state.fuelFilter) {
                    return car;
                }
            });
        }

        if (this.state.gearboxFilter) {
            filteredCars = filteredCars.filter(car => {
                if (car.skrzynia_biegow === this.state.gearboxFilter) {
                    return car;
                }
            });
        }

        if (this.gridContainedRef && this.gridContainedRef.getBoundingClientRect) {
            filteredCars.forEach((car, index) => {
                carPositions.push({
                    y:
                        this.gridContainedRef.getBoundingClientRect().y +
                        document.querySelector("#calendar").scrollTop +
                        70 * (index + 1),
                    id: car.id
                });
            });
        }

        if (!this.state.renderCom) {
            clearTimeout(this.timRender);
            this.timRender = setTimeout(() => {
                this.setState({
                    renderCom: true
                })
            }, 1000)
        }

        filteredCars = filteredCars.slice(0, Math.round(this.state.laodedF));

        return (
            <div
                style={{
                    position: "relative",
                    width: "100%"
                }}
            >
                {
                    this.state.isDialogOpen && (
                        <ReservationDialog
                            fetchCars={this.props.fetchCars.bind(
                                this,
                                this.props.token,
                                startDate,
                                endDate
                            )}
                            addCar={(id) => this.props.addCar(id, {
                                token: this.props.token,
                                startDate,
                                endDate
                            })}
                            isEdit={this.state.isEdit}
                            carId={this.state.carId}
                            closeDialog={this.onDialogCloseHandler}
                            isDialogOpen={this.state.isDialogOpen}
                            rent={this.state.rent}
                            onRentChangeHandler={this.onRentChangeHandler}
                        />
                    )
                }
                <Filters
                    filteredCars={filteredCars}
                    brandSelected={this.state.brandFilter}
                    modelSelected={this.state.modelFilter}
                    gearboxSelected={this.state.gearboxFilter}
                    onModelFilterChange={this.onModelFilterChangeHandler}
                    onBrandFilterChange={this.onBrandFilterChangeHandler}
                    onTextFilterChange={this.onTextFilterChangeHandler}
                    onFuelFilterChange={this.onFuelFilterChangeHandler}
                    onGearboxFilterChange={this.onGearboxFilterChangeHandler}
                    onFiltersReset={this.onFiltersResetHandler}
                    textFilter={this.state.textFilter}
                    fuelFilter={this.state.fuelFilter}
                />

                <PopperComponent
                    cancelRentHandler={this.cancelRentHandler}
                    editRentHandler={this.editRentHandler}
                />

                <div
                    id="calendar"
                    className={clsx(classes.calendar, {
                        [classes.calendarShift]: this.state.filtersVisible
                    })}
                >
                    {
                        daysCount > 1
                            ?
                            <LazyLoad>
                                <CarsViewWrapper
                                    callBackCarImageRef={(ref) => {
                                        if (ref && this.carImageRef != ref) {
                                            this.carImageRef = ref
                                        }
                                    }}
                                    callBackGridContainedRef={(ref) => {
                                        if (ref && this.gridContainedRef != ref) {
                                            this.gridContainedRef = ref
                                        }
                                    }}
                                    callBackCarDetailRef={(ref) => {
                                        if (ref && this.carDetailRef != ref) {
                                            this.carDetailRef = ref
                                        }
                                    }}
                                    rows={filteredCars.length + 1}
                                    columns={daysCount + 1}
                                >
                                    <React.Fragment>
                                        {
                                            [...Array(Math.floor(daysCount)).keys()].map((value, index) => (
                                                <HeaderCarsView
                                                    key={guild()}
                                                    onClick={() => {
                                                        const selectedDate = dateCarsWeekDaysView(startDate, index);
                                                        this.onDaySelectedHandler(selectedDate);
                                                    }}
                                                    index={index}
                                                    dataDate={dateCarsWeekDaysViewDisplayinPopout(startDate, index)}
                                                    callBackCellRef={(ref) => {
                                                        if (ref && this.cellRef != ref) {
                                                            this.cellRef = ref
                                                        }
                                                    }}
                                                >
                                                    <React.Fragment>
                                                        <div style={{
                                                            display: "block",
                                                            paddingBottom: "3px",
                                                            fontSize: "11px"
                                                        }}>
                                                            {dateCarsWeekDaysView(startDate, index).format("MMM")}
                                                        </div>
                                                        <div style={{
                                                            display: "block",
                                                            fontWeight: "bold",
                                                            fontSize: "14px"
                                                        }}>
                                                            {dateCarsWeekDaysView(startDate, index).format("DD")}
                                                        </div>
                                                        <div style={{ display: "block", fontSize: "11px" }}>
                                                            {dateCarsWeekDaysView(startDate, index).format("ddd")}
                                                        </div>
                                                    </React.Fragment>
                                                </HeaderCarsView>
                                            ))
                                        }

                                        {
                                            (this.cellRef && this.carImageRef && this.carDetailRef && this.gridContainedRef && this.state.renderCom) && (
                                                <CarsCalendarComponent
                                                    daysCount={daysCount}
                                                    cellRef={this.cellRef}
                                                    carImageRef={this.carImageRef}
                                                    carDetailRef={this.carDetailRef}
                                                    gridContainedRef={this.gridContainedRef}
                                                />
                                            )
                                        }

                                        {
                                            filteredCars.map((car) => (
                                                <CarRowMultipleDaysView
                                                    key={guild()}
                                                    getCorrectDateByType={this.getCorrectDateByType}
                                                    car={car}
                                                    daysCount={daysCount}
                                                    startDate={startDate}
                                                    carPositions={carPositions}
                                                    endDate={endDate}
                                                    fetchCars={this.fetchCars}
                                                    onCarIdChangeHandler={this.onCarIdChangeHandler}
                                                    onDialogOpenHandler={this.onDialogOpenHandler}
                                                    onFetchRentHandler={this.onFetchRentHandler}
                                                    editRentHandler={this.editRentHandler}
                                                    gridContainedRef={this.gridContainedRef}
                                                    cellWidth={cellWidth}
                                                />
                                            ))
                                        }
                                    </React.Fragment>
                                </CarsViewWrapper>
                            </LazyLoad>
                            :
                            <CarsViewWrapper
                                callBackCarImageRef={(ref) => {
                                    if (ref) {
                                        this.carImageRef = ref
                                    }
                                }}
                                callBackGridContainedRef={(ref) => {
                                    if (ref) {
                                        this.gridContainedRef = ref
                                    }
                                }}
                                callBackCarDetailRef={(ref) => {
                                    if (ref) {
                                        this.carDetailRef = ref
                                    }
                                }}
                                rows={filteredCars.length + 1}
                                columns={25}
                            >
                                <React.Fragment>
                                    {
                                        [...Array(24).keys()].map((value, index) => (
                                            <HeaderCarsView
                                                key={guild()}
                                                index={index}
                                                onClick={() => {
                                                    const selectedDate = dateCarsWeekDaysView(startDate, index);
                                                    this.onDaySelectedHandler(selectedDate);
                                                }}
                                                dataDate={startDate
                                                    .clone()
                                                    .add(index, "hour")
                                                    .format("YYYY-MM-DD HH:mm:ss")}
                                                callBackCellRef={(ref) => {
                                                    if (ref) {
                                                        this.cellRef = ref
                                                    }
                                                }}
                                            >
                                                {dateCarsDayHoursView(startDate, index)}.00
                                            </HeaderCarsView>
                                        ))
                                    }

                                    <CarsCalendarComponent
                                        daysCount={1}
                                        cellRef={this.cellRef}
                                        carImageRef={this.carImageRef}
                                        carDetailRef={this.carDetailRef}
                                        gridContainedRef={this.gridContainedRef}
                                    />

                                    {
                                        filteredCars.map((car) => (
                                            <CarRowOneDayView
                                                key={guild()}
                                                getCorrectDateByType={this.getCorrectDateByType}
                                                car={car}
                                                daysCount={daysCount}
                                                startDate={startDate}
                                                carPositions={carPositions}
                                                endDate={endDate}
                                                fetchCars={this.fetchCars}
                                                onCarIdChangeHandler={this.onCarIdChangeHandler}
                                                onDialogOpenHandler={this.onDialogOpenHandler}
                                                onFetchRentHandler={this.onFetchRentHandler}
                                                editRentHandler={this.editRentHandler}
                                                gridContainedRef={this.gridContainedRef}
                                                cellWidth={cellWidth}
                                            />
                                        ))
                                    }
                                </React.Fragment>
                            </CarsViewWrapper>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ...state.formReducer,
        token: state.authReducer.token
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators(ActionCreators, dispatch),
        loader: value => dispatch({ type: "REQUEST_LOADER", value: value }),
        setPeriodDataHandle: value =>
            dispatch({ type: "SET_PERIOD_DATA", value: value }),
        onSetCalendarType: value =>
            dispatch({ type: "SET_CALENDAR_TYPE", calendarType: value }),
        onRemoveType: value =>
            dispatch({ type: "REMOVE_RENT", id: value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(useStyles)(CarsView));
